import { memo } from "react";
import { FormattedMessage } from "react-intl";
import PropTypes from "prop-types";
import AmountContainer from "app/pages/.shared/AmountContainer";
import PaymentDescriptionTermsContainer from "app/pages/Booking/Payment/PaymentDescriptionTerms/PaymentDescriptionTermsContainer";
import "./MerchListingActionbar.scss";
import Typography, { TYPOGRAPHY_VARIANTS } from "app/pages/.shared/Typography/Typography";

const MerchListingActionbar = ({ label, fromPrice, hidePaymentDescriptionBlock }) => {
	return (
		<div className="merch-listing-actionbar">
			{label && (
				<Typography
					variant={TYPOGRAPHY_VARIANTS.XL3}
					variantMD={TYPOGRAPHY_VARIANTS.XL4}
					isBold
					className="merch-listing-actionbar__title"
					component="h2"
					data-testid="merch-listing-actionbar-title"
				>
					{label}
				</Typography>
			)}

			{fromPrice > 0 && (
				<Typography
					variant={TYPOGRAPHY_VARIANTS.XL}
					variantMD={TYPOGRAPHY_VARIANTS.XL2}
					isBold
					className="merch-listing-actionbar__counter"
					data-testid="merch-listing-actionbar-count"
				>
					<AmountContainer
						amount={fromPrice}
						prefix={<FormattedMessage id="general.from.label" />}
						suffix={
							<FormattedMessage id="general.amount.per.person.suffix.label.short" />
						}
					/>
				</Typography>
			)}

			{!hidePaymentDescriptionBlock && (
				<div
					className="merch-listing-actionbar__payment-terms"
					data-testid="merch-listing-actionbar-payment-terms"
				>
					<PaymentDescriptionTermsContainer />
				</div>
			)}
		</div>
	);
};

MerchListingActionbar.propTypes = {
	label: PropTypes.oneOfType([PropTypes.string, PropTypes.element, PropTypes.bool]),
	hidePaymentDescriptionBlock: PropTypes.bool,
	fromPrice: PropTypes.number,
};
export default memo(MerchListingActionbar);
